// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1JUi6","resendInfoText":"OnGoingPaymentBox_resendInfoText__2vc1P"};